import React, { useEffect, useState, useRef } from 'react';
import { useInView, animate } from 'framer-motion';
interface AnimatedCounterProps {
  value: number;
  suffix?: string;
  /** Format with thousands separator (e.g. 4000 -> 4.000) */
  separator?: boolean;
  duration?: number;
}
function formatNumber(n: number, separator?: boolean): string {
  const rounded = Math.round(n);
  if (separator) {
    return rounded.toLocaleString('es-AR');
  }
  return String(rounded);
}
export function AnimatedCounter({
  value,
  suffix = '',
  separator = false,
  duration = 2
}: AnimatedCounterProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: latest => setDisplay(latest)
    });
    return () => controls.stop();
  }, [inView, value, duration]);
  return <span ref={ref} aria-label={`${formatNumber(value, separator)}${suffix}`} data-id="element-28">
      {formatNumber(display, separator)}
      {suffix}
    </span>;
}